export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/thumbnail-football-fan-dca1ea60bd5e512f0546ba1c04b13fbd.png";